module.exports = __webpack_public_path__ + "static/Parami-84d8e2968d08759ceeccf395a1e2acf5.png";